module.exports = __webpack_public_path__ + "img/bo.0505fd9.svg";